/**
 * @generated SignedSource<<f83f4eb9acd0139af01b1dd034447f75>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FirstClientModalQuery$variables = {
  companyId: string;
};
export type FirstClientModalQuery$data = {
  readonly companyById: {
    readonly id: string;
    readonly integrations: {
      readonly nodes: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"FirstClientXeroConnectionChoices_integration">;
      }>;
    };
    readonly " $fragmentSpreads": FragmentRefs<"FirstClientIntegrationChoices_company" | "CreateClientStep_company">;
  } | null;
};
export type FirstClientModalQuery = {
  variables: FirstClientModalQuery$variables;
  response: FirstClientModalQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "companyId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "companyId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "config",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FirstClientModalQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "companyById",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FirstClientIntegrationChoices_company"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CreateClientStep_company"
          },
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "IntegrationsConnection",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Integration",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FirstClientXeroConnectionChoices_integration"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "integrations(first:100)"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FirstClientModalQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "companyById",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "IntegrationsConnection",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Integration",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "kind",
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Integration",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "integrations(first:100)"
          },
          {
            "alias": null,
            "args": (v3/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "IntegrationChoices_integrations",
            "kind": "LinkedHandle",
            "name": "integrations"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slug",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c207ad2a5965ba23c53834f92d78720c",
    "id": null,
    "metadata": {},
    "name": "FirstClientModalQuery",
    "operationKind": "query",
    "text": "query FirstClientModalQuery(\n  $companyId: ID!\n) {\n  companyById(id: $companyId) {\n    id\n    ...FirstClientIntegrationChoices_company\n    ...CreateClientStep_company\n    integrations(first: 100) {\n      nodes {\n        ...FirstClientXeroConnectionChoices_integration\n        id\n      }\n    }\n  }\n}\n\nfragment CreateClientStep_company on Company {\n  rowId\n  id\n  name\n  integrations(first: 100) {\n    nodes {\n      status\n      id\n    }\n  }\n}\n\nfragment FirstClientIntegrationChoices_company on Company {\n  id\n  rowId\n  integrations(first: 100) {\n    edges {\n      node {\n        id\n        rowId\n        kind\n        config\n        status\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  organization {\n    slug\n    id\n  }\n}\n\nfragment FirstClientXeroConnectionChoices_integration on Integration {\n  rowId\n  config\n}\n"
  }
};
})();

(node as any).hash = "96121d65acff61b518be429699c4914b";

export default node;
